import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import { Controller, useFormContext } from "react-hook-form";
import {useEffect} from "react";
import connectionActions from "../../../redux/connections/actions";
import {allRoles, genres} from "../../../assets/constants";


export default function PersonalDetails() {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
        <h5 className="fw-bold mb-3">
        Music Details
        </h5>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Controller
            name="accountType"
            control={control}
            render={({ field }) => (
              <FormControl style={{ width: "100%" }}>
                <TextField
                  id="select"
                  label="Role"
                  name="role"
                  select
                  {...field}
                  required
                  helperText={errors.gearbox ? "Select your Role" : ""}
                  error={errors.gearbox}
                >
                  {allRoles.map((genre, id) => {
                    return (
                      <MenuItem key={id} value={genre}>
                        {genre}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </FormControl>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>


          <Controller
            control={control}
            className="fw-bold mb-3"
            name="genres"
            defaultValue={[]}
            render={({ field: { onChange, onBlur, value } }) => (
              <TextField
                select
                id="genres"
                label="Genres"
                fullWidth
                helperText={errors.genre ? "You must choose a genre" : ""}
                error={errors.genre}
                SelectProps={{
                  multiple: true,
                  value: value,
                  renderValue: (selected) => selected.join(", "),
                  onChange: (e) => {
                    if(e.target.value?.length < 4) {
                      onChange(e)
                    }
                  },
                }}
              >
                {genres.map((n) => (
                  <MenuItem key={n} value={n}>
                    <Checkbox checked={value?.includes(n)} />
                    <ListItemText primary={n} />
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          
        </Grid>

        <Grid item xs={12} md={6}>
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <TextField
                required
                className="fw-bold mb-3"
                id="description"
                label="Enter Bio Description"
                name="description"
                fullWidth
                {...field}
                helperText={errors.description ? "Enter a Bio" : ""}
                error={errors.description}
              />
            )}
          />
        </Grid>
      </Grid>
    </>
  );
}
